module.exports = __webpack_public_path__ + "static/media/self.f2fbdd0d.jpg";